import React from 'react'
import { withRouter } from 'react-router-dom'

import Container from '../../views/layouts/Container'
import NavBar from './NavBar'
import Breadcrumb from './Breadcrumb'

const defaultOptions = { hasBack: true }

export const withNavigation = inputOptions =>
  function Navigation(Component) {
    return withRouter(props => {
      const options = { ...defaultOptions, ...inputOptions }
      return (
        <div>
          <NavBar
            title={options.title}
            goBack={options.hasBack ? props.history.goBack : undefined}
          />

          <Container>
            <div className="section">
              <Breadcrumb title={options.title} />
              <Component {...props} />
            </div>
          </Container>
        </div>
      )
    })
  }



// WEBPACK FOOTER //
// ./src/components/templates/navigation/withNavigation.js